import React, { useState, useEffect } from "react";
import { Typography, Grid, InputBase, Button, } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import useStyles from "./styles";
import { withSnackbar } from "../../../../../components/Message/Alert";
import { ActionDialog } from "../../../../../components/ActionDialog/ActionDialog";
import AddNewPhoto from "./components/AddPhoto";
import { PostDataAPI } from "../../../../../Services/APIService";



const CustomCard = ({programData, ...props }) => {
    const classes = useStyles();
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false,
        type: "confirm",
        message: "",
    });
    const [addNewPhoto, setAddNewPhoto] = useState(false);
    const programModal = () => {
        setAddNewPhoto(true);
    };

    const closeAddPhoto = () => {
        setAddNewPhoto(false);
    };
    const handleSuccessClose = (message) => {
        closeAddPhoto();
    }

    const [dcData, setDcData] = useState([]);


    const loadPhotos = () => {

        let obj = {
            disbursementId: null,
            collectionId: null,
            donorId: null,
            programId: programData?.programId,
            Type: "Program Photo Gallery",
            Category: "Program",
        }

        PostDataAPI("fdngrantattachments/loadGrid", obj).then((result) => {

            console.log(result);
            if (result.success && result.data != null) {
                setDcData(result.data)
            } else {
                setDcData([]);
            }
        });
    }

    useEffect(() => {
        loadPhotos()
    }, []);
    return (
        <>
            <Grid container className={classes.gridHeader}>
                <Typography variant="h5" className={classes.GridHeading}>
                    Photo Gallery
                </Typography>
                <div className={"HeaderDialog"}>
                    <div className={classes.gridActions}>
                        <Button className={classes.changeBtn} onClick={() => programModal()}>
                            <AddCircleOutlineIcon style={{ marginRight: "6px" }} /> Add Photo
                        </Button>
                    </div>
                    {/* <div className={classes.gridActions} style={{ marginRight: "7px" }}>
                        <InputBase
                            placeholder="Search"
                            className="grid-search-input"
                            // endAdornment={searchQuery ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                            startAdornment={<SearchIcon />}
                            // value={searchQuery}
                            // onChange={handleSearchChange}
                        />
                    </div> */}
                </div>
            </Grid>
            <div className={classes.DocMainDiv}>
                <Grid container spacing={2}>
                    {dcData.map((item) => (
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={6}
                            lg={3}
                            key={item.id}
                            className={classes.CardGrid}
                        >
                            <div className={classes.Card}>
                                <img src={item.filePath} />
                            </div>
                        </Grid>
                    ))}
                </Grid>
            </div>

            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState((prevState) => ({
                        ...prevState,
                        showHide: false,
                    }))
                }
                onClose={() =>
                    setActionDialogState((prevState) => ({
                        ...prevState,
                        showHide: false,
                    }))
                }
            />
            {addNewPhoto ? (
                <AddNewPhoto
                    dialogOpenClose={programModal}
                    handleClose={closeAddPhoto}
                    handleSuccessClose={handleSuccessClose}
                    programData={programData}
                // editProgram={editData} // Conditionally pass EditProgram
                ></AddNewPhoto>
            ) : (
                ""
            )}
        </>
    );
};

export default withSnackbar(CustomCard);
